
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/routine/[shortId]",
      function () {
        return require("private-next-pages/routine/[shortId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/routine/[shortId]"])
      });
    }
  